export const SHOPIFY_INTEGRATION_TYPE = 'shopify';
export const WOO_COMMERCE_INTEGRATION_TYPE = 'woo_commerce';

export const CUSTOM_INTEGRATION_DISPLAY_NAME = 'Custom';

export const IntegrationDisplayNames = {
  '3pl_central': '3PL Central',
  a2k: 'A2K',
  abg_edi: 'EDI',
  acumatica: 'Acumatica',
  apparelmagic: 'Apparel Magic',
  amazon_mcf: 'Amazon MCF',
  balmain: CUSTOM_INTEGRATION_DISPLAY_NAME,
  bbby: CUSTOM_INTEGRATION_DISPLAY_NAME,
  bergen: 'Bergen Logistics',
  bigcommerce: 'BigCommerce',
  blue_cherry: 'Blue Cherry',
  cin7: 'Cin 7',
  cosabella_eu: CUSTOM_INTEGRATION_DISPLAY_NAME,
  ctfna: CUSTOM_INTEGRATION_DISPLAY_NAME,
  cymbio_api: 'API',
  cymbio_edi: 'EDI',
  cymbio_manual: 'Manual',
  desktop_shipper: 'Desktop Shipper',
  edi: 'EDI',
  email: 'Email',
  file: 'File',
  full_circle: 'Full Circle',
  grendene: CUSTOM_INTEGRATION_DISPLAY_NAME,
  gstar: CUSTOM_INTEGRATION_DISPLAY_NAME,
  incomm: CUSTOM_INTEGRATION_DISPLAY_NAME,
  island_pacific: 'Island Pacific',
  jazz_central: 'JAZZ WMS',
  kering: CUSTOM_INTEGRATION_DISPLAY_NAME,
  la_canadienne: CUSTOM_INTEGRATION_DISPLAY_NAME,
  lacoste: CUSTOM_INTEGRATION_DISPLAY_NAME,
  m3: 'M3',
  magento2: 'Magento',
  mi9: 'MI9',
  netsuite: 'Netsuite',
  new_balance: CUSTOM_INTEGRATION_DISPLAY_NAME,
  owd: CUSTOM_INTEGRATION_DISPLAY_NAME,
  pikolinos: CUSTOM_INTEGRATION_DISPLAY_NAME,
  quiet_logistics: 'Quite Logistics',
  reebok: 'MAO',
  rlm: 'RLM',
  salesforce: 'SFCC OMS',
  salesforce_commerce_cloud: 'SFCC',
  sap_hana: 'SAP',
  sci: CUSTOM_INTEGRATION_DISPLAY_NAME,
  ship_bob: 'Ship Bob',
  shipstation: 'Shipstation',
  shopify: 'Shopify',
  sku_vault: 'Sku Vault',
  spree: 'Spree',
  sumr: CUSTOM_INTEGRATION_DISPLAY_NAME,
  sunnylife: CUSTOM_INTEGRATION_DISPLAY_NAME,
  tradegecko: 'TradeGecko',
  visualnext: 'Visual Next',
  woo_commerce: 'Woo Commerce',
};
